import type { ReactNode } from 'react';

interface DecorativeCirclesProps {
  children: ReactNode;
  badgeClassName?: string;
}

export function DecorativeCircles({
  children,
  badgeClassName = 'bg-brand-primary',
}: DecorativeCirclesProps) {
  return (
    <div className="relative mb-6 flex items-center justify-center">
      <svg
        className="absolute size-[320px]"
        viewBox="0 0 320 320"
        fill="none"
        aria-hidden="true"
        role="presentation"
        focusable="false"
      >
        {[150, 115, 80, 45].map((r) => (
          <circle
            key={r}
            cx="160"
            cy="160"
            r={r}
            stroke="var(--color-border-secondary)"
            strokeWidth="1"
            opacity="0.5"
          />
        ))}
      </svg>

      <div
        className={`relative z-10 flex size-14 items-center justify-center rounded-full ${badgeClassName}`}
      >
        {children}
      </div>
    </div>
  );
}
